export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
  /** Where the quote comes from, shown as a pill (voice-of-customer cards). */
  source?: string
  /** City and country, shown under the role. */
  location?: string
}

/** Reviews from instructors who used Sailing Lesson Ready. */
export const instructorReviews: Testimonial[] = [
  {
    quote:
      'I used to stress every time the forecast shifted. With Sailing Lesson Ready, I can open the Light Air, Right Air, or Wrong Air version and keep the same learning goal. My students stay engaged, and I feel prepared from the first lesson card to week ten.',
    author: 'Jessica Miller',
    role: 'Sailing instructor',
  },
  {
    quote:
      'The season flow is the best part. It’s organized like a real program, not random drills. Our juniors and our intermediate sailors progressed smoothly, and on rainy days we still had structured, safe shore lessons instead of cancellations.',
    author: 'Michael Chen',
    role: 'Sailing program lead',
  },
  {
    quote:
      'As a coach, I’m always looking for clarity I can follow on the dock. The Any-Wind Lesson System made our team consistent, and the safety notes saved us from last-minute improvising. We finished the season feeling like we actually trained toward something.',
    author: 'Ashley Johnson',
    role: 'Sailing coach',
  },
]

/**
 * Public comments from the DPS48 product research (ficha de producto, VOC).
 * They are NOT reviews of this pack. Swap in real buyer reviews (with permission)
 * as they arrive.
 */
export const fromTheDock: Testimonial[] = [
  {
    quote: 'There are times it feels like the weather is against us.',
    author: 'National sailing federation (Australia)',
    role: 'On windy-day alternative activities for instructors',
    source: 'sailing.org.au',
  },
  {
    quote: '…may kill time until the breeze fills.',
    author: 'Sail1Design',
    role: 'On lecturing at a marker board while waiting for wind',
    source: 'sail1design.com',
  },
  {
    quote: 'Great way to keep a class busy on a windless day.',
    author: 'Forum member',
    role: 'Replying to a thread on no-wind training days',
    source: 'sailboatowners.com',
  },
]

export const askedFor: Testimonial[] = [
  {
    quote: '…have a basic lesson plan formulated.',
    author: 'WindCheck Magazine',
    role: 'On what instructors should bring to a junior program',
    source: 'windcheckmagazine.com',
  },
  {
    quote: 'Make sure sailors have the skills needed to be successful at the drill.',
    author: 'Sailing leadership resource',
    role: 'On running drills that fit the group',
    source: 'sailingleadership.org',
  },
]

export const everySeason: Testimonial[] = [
  {
    quote: '…there is a never-ending need for new blood.',
    author: 'Sailing World',
    role: 'On young instructors joining programs every season',
    source: 'sailingworld.com',
  },
  {
    quote: 'Assuming that last summer/session is exactly like this summer/session is a mistake.',
    author: 'National sailing federation (US)',
    role: 'On preparing staff for the start of the season',
    source: 'ussailing.org',
  },
]
